import { required, requiredIf } from 'vuelidate/lib/validators';
import {
  KIVO_NO_ENGAGEMENT_WAIT_MINUTES,
  MACRO_DELAY_MINUTES,
} from 'dashboard/routes/dashboard/settings/automation/constants';

const leadQualityScoreInRange = (value, parent) => {
  if (!parent || parent.attribute_key !== 'lead_quality_score') return true;
  const single = Array.isArray(value) ? value[0] : value;
  if (single === '' || single === null || single === undefined) return true;
  const n = Number(single);
  return Number.isFinite(n) && Number.isInteger(n) && n >= 1 && n <= 100;
};

const reengagementCountValid = (value, parent) => {
  if (!parent || parent.attribute_key !== 'reengagement_count') return true;
  const single = Array.isArray(value) ? value[0] : value;
  if (single === '' || single === null || single === undefined) return true;
  const n = Number(single);
  return Number.isFinite(n) && Number.isInteger(n) && n >= 0;
};

const kivoWebhookParamsValid = (value, action) => {
  if (!action) return true;

  if (action.action_name === 'send_kivo_notification') {
    const params = value || {};
    const url = typeof params.url === 'string' ? params.url.trim() : '';
    const text = typeof params.text === 'string' ? params.text.trim() : '';
    return url.length > 0 && text.length > 0;
  }

  if (action.action_name === 'send_kivo_notification_on_no_engagement') {
    const params = value || {};
    const url = typeof params.url === 'string' ? params.url.trim() : '';
    const text = typeof params.text === 'string' ? params.text.trim() : '';
    const wait = Number(params.wait_time_minutes);
    return (
      url.length > 0 &&
      text.length > 0 &&
      Number.isFinite(wait) &&
      Number.isInteger(wait) &&
      wait >= KIVO_NO_ENGAGEMENT_WAIT_MINUTES.MIN &&
      wait <= KIVO_NO_ENGAGEMENT_WAIT_MINUTES.MAX
    );
  }

  return true;
};

const whatsappTemplateParamsValid = (value, action) => {
  if (!action || action.action_name !== 'send_whatsapp_template') return true;

  const params = value || {};
  const source = Array.isArray(params) ? params[0] : params;
  const inboxId = source?.inbox_id;
  const macroId = source?.macro_id;

  return (
    inboxId !== null &&
    inboxId !== undefined &&
    inboxId !== '' &&
    macroId !== null &&
    macroId !== undefined &&
    macroId !== ''
  );
};

const macroDelayMinutesValid = (value, action) => {
  if (
    !action ||
    (action.action_name !== 'add_macro' &&
      action.action_name !== 'send_whatsapp_template')
  ) {
    return true;
  }
  if (value === '' || value === null || value === undefined) return true;

  const delay = Number(value);
  if (delay === 0) return true;

  return (
    Number.isFinite(delay) &&
    Number.isInteger(delay) &&
    delay >= MACRO_DELAY_MINUTES.MIN &&
    delay <= MACRO_DELAY_MINUTES.MAX
  );
};

export default {
  validations: {
    automation: {
      name: {
        required,
      },
      description: {
        required,
      },
      event_name: {
        required,
      },
      conditions: {
        required,
        $each: {
          values: {
            required: requiredIf(prop => {
              return !(
                prop.attribute_key === 'meeting_present' ||
                prop.filter_operator === 'is_present' ||
                prop.filter_operator === 'is_not_present'
              );
            }),
            leadQualityScoreInRange,
            reengagementCountValid,
          },
        },
      },
      actions: {
        required,
        $each: {
          action_params: {
            required: requiredIf(prop => {
              return !(
                prop.action_name === 'mute_conversation' ||
                prop.action_name === 'snooze_conversation' ||
                prop.action_name === 'resolve_conversation' ||
                prop.action_name === 'gather_lead_quality_score' ||
                prop.action_name === 'send_kivo_notification' ||
                prop.action_name === 'send_kivo_notification_on_no_engagement' ||
                prop.action_name === 'send_whatsapp_template'
              );
            }),
            kivoWebhookParamsValid,
            whatsappTemplateParamsValid,
          },
          delay_minutes: {
            macroDelayMinutesValid,
          },
        },
      },
    },
  },
};
